import React  from "react";
import { Link } from 'react-router-dom';

function Header()
{
    return(
        
         <>
       <header>
         <nav>
              <ul className="myul">
            <li><Link to="/" className="link">Home</Link></li>
            <li><Link to="/about" className="link">About</Link></li>
            <li><Link to="/services" className="link">Services</Link></li>
            <li><Link to="/contact" className="link">Contact</Link></li>           
              </ul>
         </nav>
       </header>

         </>
);

};

export default Header;